/**
 * Avatar generator.
 */
class AvatarMaker {
  get(name) {
    let fc = name.charAt(0);
    if (!this.#avatars.has(fc)) {
      let avatarSVG = `
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 320 320" width="320" height="320">
          <rect width="320" height="320" opacity="1" fill="#d6e2ff" fill-opacity="1"></rect>
          <text x="70" y="250" opacity="1" fill="#0069ff" fill-opacity="1"
                font-size="277" font-family="monospace">${fc}</text>
          <text x="70" y="250" opacity="1" fill-opacity="0"
                stroke="#51454b" stroke-width="1" stroke-opacity="1"
                font-size="277" font-family="monospace">${fc}</text>
        </svg>
      `;
      let avatar = `data:image/svg+xml;utf8,${encodeURIComponent(avatarSVG)}`;
      this.#avatars.set(fc, avatar);
    }
    return this.#avatars.get(fc);
  }

  #avatars = new Map();
}

const avatarMaker = new AvatarMaker();

export { avatarMaker };
